import React from "react";
import SportCode from "components/common/SportCode";
import { dateFormat } from "helpers/utils"
import ScoresLiveCard from "components/common/ScoresLiveCard";
import { Link } from "react-router-dom";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { Score as ScoreGlobal } from "components/presentation/Score"
import { getEventRSC } from "helpers/rsc";


export function Footer({ data, period, mirs_discipline }) {
    return <div className='scores-today-status'>{period === undefined && (data?.status?.description)} <SportCode discipline={mirs_discipline} entity='@Period' code={period} /></div>
}

export function Header({ data }) {
    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste'>{data?.location?.longDescription}</div>
            <div className='scores-today-unit-time'>
                <div className='flex-grow-1'>
                    {data?.eventUnit?.description}
                </div>
                <div className='text-end'>
                    {dateFormat(data?.startDate, undefined, 'HH:mm')}{ }
                </div>
            </div>
        </div></>
    )
}

export function CardsLayout({ results }) {

    return (<>
        <div className="scores-today-container">
            {results && results?.map(item => {
                return (<ScoresLiveCard data={item} key={item?.eventUnit?.code} />)
            })}
        </div>
    </>
    );
}

export function BodyComponent({ data, competitorComponent, competitorNoDataComponent }) {
    const CompetitorComponent = competitorComponent || <></>
    const CompetitorNoDataComponent = competitorNoDataComponent || <></>
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const getURL = useGetURL()
    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')
    let sortedItems = Array.isArray(data?.result?.items) ? data?.result?.items.sort((a, b) => a.sortOrder - b.sortOrder) : undefined;
    const out = sortedItems?.map(item => {
        let color = item?.eventUnitEntries?.find(eventUnitEntry => eventUnitEntry?.eue_code === 'COLOUR')?.eue_value?.toLowerCase();
        return (
            <Link key={item?.sortOrder} to={url} >
                <div className={mirs_discipline === 'TTE' ? 'score-line justify-content-between d-flex flex-row ' : ' score-line d-flex flex-row  '}>
                    {item?.participant ? <CompetitorComponent extendedInfos={data?.result?.extendedInfos} {...item} /> : <CompetitorNoDataComponent {...item} />}
                    {/** Results in match */}
                    <ScoreGlobal resultJson={item?.resultDataText} discipline={mirs_discipline} />
                </div>
            </Link>
        )
    })

    return (
        <>{out}</>
    )

}